import React from "react";
import ToggleSwitch from "../Forms/Input/ToggleSwitch";

interface UiVisibilityCardProps {
  code: string;
  label: string;
  icon?: JSX.Element;
  visible: boolean;
  onToggle: () => void;
}

/**
 * 💡 Card individual de configuración UI (versión compacta)
 */
const UiVisibilityCard: React.FC<UiVisibilityCardProps> = ({
  code,
  label,
  icon,
  visible,
  onToggle,
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-between rounded-xl border p-4 transition-all duration-300 shadow-sm hover:shadow-md
        ${
          visible
            ? "border-[#3CA745] hover:shadow-[0_0_12px_rgba(60,167,69,0.2)] dark:border-[#3CA745]"
            : "border-[#DC3545] hover:shadow-[0_0_12px_rgba(220,53,69,0.2)] dark:border-[#DC3545]"
        } 
        bg-white dark:bg-boxdark`}
    >
      {/* 🔝 Título */}
      <h3 className="mb-3 text-sm font-semibold text-gray-800 dark:text-white text-center">
        {label}
      </h3>

      {/* 🎨 Icono central (equilibrado) */}
      <div
        className={`mb-5 flex h-16 w-16 items-center justify-center rounded-full transition-all duration-300
          ${
            visible
              ? "bg-[#3CA745]/10 text-[#3CA745] dark:bg-[#3CA745]/20 dark:text-[#3CA745]"
              : "bg-[#DC3545]/10 text-[#DC3545] dark:bg-[#DC3545]/20 dark:text-[#DC3545]"
          }`}
      >
        {icon &&
          React.cloneElement(icon, {
            width: 32,
            height: 32,
          })}
      </div>

      {/* 🔘 Toggle inferior */}
      <div className="w-full">
        <ToggleSwitch
          label={visible ? "Visible" : "Oculto"}
          name={code}
          checked={visible}
          onChange={onToggle}
          activeColor="success"
          inactiveColor="danger"
        />
      </div>
    </div>
  );
};

export default UiVisibilityCard;
